import React from 'react'
import CustomDialog from '../../../shared/layout/custom-dialog'
import {Box, Button, Typography} from '@material-ui/core'
import {useStyles} from './portfolio-setup-info-styles'
import {HelpOutline} from '@material-ui/icons'

export function PortfolioSetupInfo() {
    const styles = useStyles()
    return <CustomDialog
        trigger={
            <Button
                variant='text'
                size='medium'
                color='primary'
                className={styles.portfolioBtn}
                data-testid='instructions'
                startIcon={<HelpOutline />}
            >
                PORTFOLIO SETUP
            </Button>
        }
        title={'Portfolio Setup'}
    >
        <Box className={styles.portfolioDialog}>
            <Typography className={styles.portfolioTitle}> To set up your portfolio, you can:</Typography>
            <ol>
                <li className={styles.typography}>
                    Add individual companies from the <b className={styles.typographyBold}>All Companies</b> or <b className={styles.typographyBold}>Watchlist</b> tabs.
                </li>
                <li className={styles.typography}>
                    Add multiple companies at once by selecting <b className={styles.typographyBold}>Team Codes</b> above.
                </li>
            </ol>
        </Box>
    </CustomDialog>;
}